export default __webpack_public_path__ + "static/media/FkText.7ae78845.svg";